const zzzfunScreenshots = [
  {
    title: '番剧播放页面',
    desc: '线路切换 · 剧集清晰',
    alt: 'ZzzFun番剧播放页面截图',
    img: '/images/zzzfun-shot-play.png',
  },
  {
    title: '番剧分类布局',
    desc: '按题材精准找番',
    alt: 'ZzzFun番剧分类布局截图',
    img: '/images/zzzfun-shot-category.png',
  },
  {
    title: '番剧简介界面',
    desc: '剧情介绍一目了然',
    alt: 'ZzzFun番剧简介界面截图',
    img: '/images/zzzfun-shot-intro.png',
  },
  {
    title: '移动端首页',
    desc: '兴趣推荐直达精彩',
    alt: 'ZzzFun移动端首页截图',
    img: '/images/zzzfun-app-home.png',
  },
  {
    title: '最近更新页面',
    desc: '新番动态实时同步',
    alt: 'ZzzFun最近更新页面截图',
    img: '/images/zzzfun-shot-update.png',
  },
];

export default function ZzzfunScreenshots() {
  return (
    <section id="zzzfun-screenshots" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-bold uppercase tracking-widest text-accent-600">Screenshots</span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">截图预览</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            看看ZzzFun客户端在各个场景下的真实界面，简洁直观，上手即用。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 justify-items-center gap-5 sm:grid-cols-3 lg:grid-cols-5">
          {zzzfunScreenshots.map((shot, index) => (
            <div key={shot.title} className="flex flex-col items-center">
              <div className="relative h-[300px] w-[176px] overflow-hidden rounded-xl border-4 border-foreground-900 bg-foreground-900 md:h-[340px] md:w-[200px]">
                <img
                  src={shot.img}
                  alt={shot.alt}
                  title={`ZzzFun动漫官网下载-${shot.title}`}
                  className="h-full w-full object-cover object-top"
                />
                <span className="absolute left-2 top-2 flex h-6 w-6 items-center justify-center rounded-full bg-primary-500 text-[11px] font-bold text-background-50 dark:text-foreground-950">
                  {index + 1}
                </span>
              </div>
              <h3 className="mt-3 text-sm font-bold text-foreground-950">{shot.title}</h3>
              <p className="mt-0.5 text-center text-xs text-foreground-600">{shot.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}